<template>
  <section class="content-polity container">
    <div class="content-polity--text">
      <h1>Política e Privacidade</h1>
      <p>Esta Política de Privacidade descreve como Alpha Softwares, com sede em Belo Horizonte, Minas Gerais - Brasil, doravante referida como "Fornecedor", coleta, usa, armazena e protege informações pessoais de usuários do aplicativo Evolution ou Salon Date. Ao utilizar o Aplicativo, você concorda com as práticas descritas nesta Política de Privacidade.</p>
      <h2>1. Informações Coletadas:</h2>
        <p>1.1. Dados de Registro: Quando você cria uma conta no Aplicativo, podemos coletar informações como nome, endereço de e-mail, data de nascimento e senha.</p>
        <p>1.2. Informações de Uso: Podemos coletar informações sobre como você utiliza o Aplicativo, incluindo interações com o conteúdo, exercícios realizados e progresso alcançado.</p>
        <p>1.3. Informações de Dispositivo: Podemos coletar informações técnicas sobre o dispositivo que você usa para acessar o Aplicativo, como modelo de dispositivo, sistema operacional, versão do aplicativo e identificadores únicos.</p>
        <p>1.4. Informações de Localização: Podemos coletar informações de localização se você permitir o acesso a serviços de localização em seu dispositivo. Essas informações podem ser usadas para personalizar sua experiência no Aplicativo.</p>
      <h2>2. Uso das Informações:</h2>
        <p>2.1. Personalização: As informações coletadas podem ser usadas para personalizar sua experiência no Aplicativo, fornecendo recomendações de conteúdo e exercícios relevantes.</p>
        <p>2.2. Melhoria do Aplicativo: As informações podem ser usadas para melhorar o Aplicativo, seus recursos e funcionalidades, com base nos padrões de uso e feedback dos usuários.</p>
        <p>2.3. Comunicação: Podemos usar seu endereço de e-mail para enviar atualizações, notificações e informações relacionadas ao Aplicativo. Você pode optar por não receber essas comunicações a qualquer momento.</p>
        <p>2.4. Análise e Pesquisa: As informações podem ser utilizadas para análises estatísticas e pesquisas internas, visando entender melhor as necessidades dos usuários e aprimorar o Aplicativo.</p>
      <h2>3. Compartilhamento de Informações:</h2>
        <p>3.1. Parceiros e Prestadores de Serviços: Podemos compartilhar informações com parceiros e prestadores de serviços que nos auxiliam na operação do Aplicativo, como processamento de pagamentos e análises de dados. Essas entidades estão sujeitas a obrigações de confidencialidade.</p>
        <p>3.2. Requisitos Legais: Podemos compartilhar informações quando necessário para cumprir obrigações legais, responder a processos legais ou proteger nossos direitos, propriedade ou segurança, ou a de terceiros.</p>
      <h2>4. Segurança:</h2>
        <p>4.1. Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, uso indevido, alteração ou divulgação.</p>
        <p>4.2. No entanto, nenhum método de transmissão pela internet ou método de armazenamento eletrônico é totalmente seguro. Não podemos garantir a segurança absoluta das informações.</p>
      <h2>5. Seus Direitos:</h2>
        <p>5.1. Você tem o direito de acessar, corrigir, atualizar e excluir suas informações pessoais, sujeito às limitações legais.</p>
        <p>5.2. Você pode optar por não fornecer certas informações, mas isso pode afetar sua capacidade de usar alguns recursos do Aplicativo.</p>
      <h2>6. Crianças:</h2>
        <p>6.1. O Aplicativo não se destina a crianças menores de 18 anos. Não coletamos intencionalmente informações pessoais de crianças. Se você acredita que uma criança nos forneceu informações pessoais, entre em contato conosco imediatamente.</p>
      <h2>7. Alterações na Política de Privacidade:</h2>
        <p>7.1. Reservamo-nos o direito de modificar esta Política de Privacidade a qualquer momento. As alterações serão publicadas no Aplicativo. O uso contínuo do Aplicativo após tais alterações constitui sua aceitação das mudanças.</p>
        <p>Se você tiver alguma dúvida ou preocupação sobre esta Política de Privacidade, entre em contato conosco em <button @click="sendEmail()">alphasoftwaresapps@gmail.com</button></p>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      emailCompany: 'alphasoftwaresapps@gmail.com',
    }
  },
  methods: {
    sendEmail() {
      window.location.href=`mailto:${this.emailCompany}`;
    },
  }
}
</script>

<style lang="scss">
.content-polity {
  padding-top: 70px;
  padding-bottom: 150px;
  @media (max-width: 767px){
    padding: 50px 30px 150px 30px;
  }
  &--text {
    text-align: left;
    margin-bottom: 30px;
    h1 {
      font-size: 24px;
      font-family: 'Font Semibold';
      color: var(--black);
      line-height: 1;
      margin-bottom: 30px;
    }
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      line-height: 1;
      margin: 30px 0px;
    }
    p {
      font-size: 16px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 15px;
      button {
        display: flex;
        background: 0;
        border: 0;
        padding: 0;
        color: var(--blue);
        text-decoration: underline !important;
      }
    }
  }
}
</style>
